/**
 * @generated SignedSource<<d0557ec00e2ef86d143550684d232895>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductAppKind = "chat_channel" | "collection" | "content" | "curriculum" | "dashboard" | "events" | "group_directory" | "link" | "member_directory" | "members" | "nav_folder" | "organization_events" | "organization_members" | "posts" | "product_link" | "resources" | "slack" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useConnectedProductAppsActiveProductFragment$data = {
  readonly connectedApps: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly kind: ProductAppKind;
      };
    }>;
  };
  readonly " $fragmentType": "useConnectedProductAppsActiveProductFragment";
};
export type useConnectedProductAppsActiveProductFragment$key = {
  readonly " $data"?: useConnectedProductAppsActiveProductFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useConnectedProductAppsActiveProductFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useConnectedProductAppsActiveProductFragment",
  "selections": [
    {
      "alias": "connectedApps",
      "args": [
        {
          "kind": "Literal",
          "name": "includeNested",
          "value": true
        }
      ],
      "concreteType": "ProductAppNodeConnection",
      "kind": "LinkedField",
      "name": "productApps",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductAppNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductApp",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "kind",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "productApps(includeNested:true)"
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "66e992caa7d780c9cf996873d6217e19";

export default node;
